import React, { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "./firebaseConfig";
import { Link, useNavigate } from "react-router-dom";

export default function SignUpPage() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    location: "South Africa",
    company: "",
    password: "",
  });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const countries = [
    "South Africa", "United States", "Canada", "United Kingdom", "Australia",
    "Germany", "France", "India", "China", "Japan", "Brazil", "Mexico",
    "Netherlands", "Italy", "Spain", "Kenya", "Nigeria", "Egypt", "Russia",
    "Argentina", "Colombia", "Indonesia", "Thailand", "Philippines"
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await createUserWithEmailAndPassword(auth, formData.email, formData.password);
      navigate("/app-setup");
    } catch (err) {
      setError("Sign up failed. Please check your details.");
    }
  };

  return (
    <div className="min-h-screen bg-[#0b0f19] text-white flex flex-col items-center justify-center px-4">
      {/* Clickable logo top left */}
      <Link to="/" className="absolute top-6 left-6 flex items-center space-x-2">
        <div className="bg-cyan-500 text-[#0b0f19] font-bold text-xl w-10 h-10 flex items-center justify-center rounded-full">IM</div>
        <span className="text-xl font-semibold text-cyan-400">Invoice Mate</span>
      </Link>

      <div className="bg-[#101926] p-8 rounded-xl shadow-lg w-full max-w-md mt-12">
        <h2 className="text-2xl font-bold mb-6 text-center text-cyan-400">Sign Up</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block mb-1 text-sm">First Name</label>
            <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required className="w-full px-4 py-2 bg-[#0b0f19] border border-gray-700 rounded text-white" />
          </div>
          <div>
            <label className="block mb-1 text-sm">Last Name</label>
            <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required className="w-full px-4 py-2 bg-[#0b0f19] border border-gray-700 rounded text-white" />
          </div>
          <div>
            <label className="block mb-1 text-sm">Email</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 bg-[#0b0f19] border border-gray-700 rounded text-white" />
          </div>
          <div>
            <label className="block mb-1 text-sm">Phone (ZA +27)</label>
            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-2 bg-[#0b0f19] border border-gray-700 rounded text-white" />
          </div>
          <div>
            <label className="block mb-1 text-sm">Location</label>
            <select name="location" value={formData.location} onChange={handleChange} className="w-full px-4 py-2 bg-[#0b0f19] border border-gray-700 rounded text-white">
              {countries.map((country) => (
                <option key={country} value={country}>{country}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block mb-1 text-sm">Company (Optional)</label>
            <input type="text" name="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-2 bg-[#0b0f19] border border-gray-700 rounded text-white" />
          </div>
          <div>
            <label className="block mb-1 text-sm">Password</label>
            <input type="password" name="password" value={formData.password} onChange={handleChange} required className="w-full px-4 py-2 bg-[#0b0f19] border border-gray-700 rounded text-white" />
          </div>

          {error && <p className="text-red-500 text-sm">{error}</p>}

          <button type="submit" className="w-full bg-cyan-500 hover:bg-cyan-400 text-white py-2 rounded-full font-medium transition">Sign Up</button>
        </form>

        <p className="text-sm text-center mt-4">
          Already have an account?{' '}
          <Link to="/login" className="text-cyan-400 hover:underline">Sign In</Link>
        </p>
      </div>
    </div>
  );
}
